import React from 'react';
import { Route, Switch } from 'react-router';
import { eCommerceMenuRoutes } from '../constants';

export const EcommerceMenuRoutes = () => {

  return (
		<Switch>
			{
				[eCommerceMenuRoutes.map((route, index) => {
					return (
						<Route 
							key={index}
							path={route.path}
							exact={route.exact}
							render={() => <route.component />} />													
					)
					})					
				]
			}
		</Switch>
	);
}